import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const NumeroDocumentoMedio2FormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='N. DOC' htmlFor='input-numeroDocumentoMedio2' md={5} alignRightAt='md' />
      <Col md={7}>
        <Field name='numeroDocumentoMedio2'>
          {({ field }) => <Form.InputText {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='input-numeroDocumentoMedio2' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroDocumentoMedio2FormGroup)
